import React from 'react';
import MarketPreviews from 'app/shared/components/MarketPreviews';
import { gaEvents } from 'app/shared/constants/AnalyticsConstants';
import type { Market } from 'app/shared/types/Market';

interface NearbyAreaTrendsProps {
    nearbyAreaTrends: Array<Market>;
    isSmallScreen: boolean;
    isMobile: boolean;
}

const NearbyAreaTrends: React.FunctionComponent<NearbyAreaTrendsProps> = (props) => {
    const { nearbyAreaTrends, isSmallScreen, isMobile } = props;
    return (
        <MarketPreviews
            markets={nearbyAreaTrends}
            heading="Nearby Area Trends"
            subject="nearby areas"
            isSmallScreen={isSmallScreen}
            isMobile={isMobile}
            gaEvent={gaEvents.VIEW_NEARBY_AREA}
        />
    );
};

export default NearbyAreaTrends;
